import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgLinkedin = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#0061CD"
      d="M31 5H9a4 4 0 0 0-4 4v22a4 4 0 0 0 4 4h22a4 4 0 0 0 4-4V9a4 4 0 0 0-4-4"
    />
    <path
      fill="#00215B"
      d="M22 33v-1h11a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3H11a3 3 0 0 0-3 3v11H7V7a4 4 0 0 1 4-4h22a4 4 0 0 1 4 4v22a4 4 0 0 1-4 4zm0 0v-1h11a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3H11a3 3 0 0 0-3 3v11H7V7a4 4 0 0 1 4-4h22a4 4 0 0 1 4 4v22a4 4 0 0 1-4 4z"
    />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M28 26.971h-3.315v-5.188c0-1.237-.022-2.828-1.723-2.828-1.725 0-1.988 1.348-1.988 2.74v5.276h-3.312V16.303h3.178v1.459h.046c.442-.839 1.524-1.724 3.137-1.724 3.357 0 3.977 2.209 3.977 5.082zM13.924 14.846a1.923 1.923 0 1 1-.003-3.845 1.923 1.923 0 0 1 .003 3.845m1.658 12.125h-3.319V16.303h3.319z"
      clipRule="evenodd"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgLinkedin);

export default ForwardRef;
